const HamburgerIcon = ({ color = 'currentColor', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<defs />
			<path
				fill={color}
				d="M20.75,5 C20.75,5.414 20.414,5.75 20,5.75 L4,5.75 C3.586,5.75 3.25,5.414 3.25,5 C3.25,4.586 3.586,4.25 4,4.25 L20,4.25 C20.414,4.25 20.75,4.586 20.75,5 Z M20,18.25 C20.414,18.25 20.75,18.586 20.75,19 C20.75,19.414 20.414,19.75 20,19.75 L4,19.75 C3.586,19.75 3.25,19.414 3.25,19 C3.25,18.586 3.586,18.25 4,18.25 Z M20.75,12 C20.75,12.414 20.414,12.75 20,12.75 L10,12.75 C9.586,12.75 9.25,12.414 9.25,12 C9.25,11.586 9.586,11.25 10,11.25 L20,11.25 C20.414,11.25 20.75,11.586 20.75,12 Z"
			/>
		</svg>
	);
};

export default HamburgerIcon;
